import { motion } from "framer-motion";
import trackingIcon from "./assets/operational.svg";
import routeIcon from "./assets/data.svg";
import dispatchIcon from "./assets/empolyee.svg";
import analyticsIcon from "./assets/process.svg";
import alertsIcon from "./assets/center.svg";

const AutomatedBenefits = () => {
    const featuress = [
        {
            id: "operational-efficiency",
            icon: trackingIcon,
            title: "Operational Efficiency",
            desc: "Automates HR tasks, freeing time for strategic initiatives.",
            delay: 0.1,
        },
        {
            id: "data-accuracy",
            icon: routeIcon,
            title: "Data Accuracy",
            desc: "Employees manage data, reducing errors and improving reliability.",
            delay: 0.2,
        },
        {
            id: "employee-empowerment",
            icon: dispatchIcon,
            title: "Employee Empowerment",
            desc: "ESS gives control, boosting trust and engagement levels.",
            delay: 0.3,
        },
        {
            id: "process-automation",
            icon: analyticsIcon,
            title: "Process Automation",
            desc: "Leave workflows auto-route, speeding approvals and notifications.",
            delay: 0.4,
        },
        {
            id: "centralized-access",
            icon: alertsIcon,
            title: "Centralized Access",
            desc: "ESS unifies info, reducing confusion and repeated queries.",
            delay: 0.5,
        },
    ];

    return (
        <section className="w-full bg-white py-14 px-6 md:px-16 lg:px-24 font-epilogue text-gray-900">

            <div className="max-w-7xl mx-auto mb-16">
                <h2 className="font-semibold text-[48px] leading-tight mb-4">
                    How it benefits <br /> your organization?
                </h2>
                <p className="text-gray-600 font-normal text-[16px] max-w-3xl">
                    JIVIEWS enhances organizational efficiency by streamlining workflows,
                    improving visibility, and enabling smarter decision-making.
                </p>
            </div>


            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
                {featuress.map((item) => (
                    <motion.div
                        key={item.id}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{
                            duration: 0.6,
                            delay: item.delay,
                            ease: "easeOut",
                        }}
                        whileHover={{
                            y: -5,
                            scale: 1.03,
                            boxShadow: "0px 10px 25px rgba(102, 51, 255, 0.15)",
                        }}
                        className="relative bg-[#EDEEFF] hover:bg-[#eef0ff] rounded-2xl pt-12 pb-6 px-6 shadow-sm transition-all duration-300"
                    >

                        <motion.div
                            className="absolute -top-5 left-6 p-2"
                            whileHover={{ rotate: 5 }}
                            transition={{ type: "spring", stiffness: 120 }}
                        >
                            <img src={item.icon} alt={item.title} className="w-10 h-10" />
                        </motion.div>


                        <h3 className="font-semibold text-lg mb-2 mt-2">
                            {item.title}
                        </h3>
                        <p className="text-gray-600 text-sm leading-relaxed">
                            {item.desc}
                        </p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default AutomatedBenefits;
